import { Box, Stack, StackProps } from '@chakra-ui/react';
import { FC } from 'react';
import * as Sentry from '@sentry/react';
import { useAppContext } from '@frx/frx-react-context';
import { useLocation } from 'react-router-dom';
import { UserNavigation } from '../../user-navigation';

export interface PageProps extends StackProps {
  noSidebar?: string[];
}

export const Page: FC<PageProps> = ({ children, noSidebar, ...rest }) => {
  const location = useLocation();
  const {
    data: {
      authData: { user },
      eventData: { eventInfo, eventConfig },
    },
  } = useAppContext();
  const hasNoSidebar = noSidebar?.includes(location.pathname);

  // Sentry tags for filtering based on event and user
  Sentry.setTag('fr_id', eventInfo?.id);

  return (
    <Stack
      direction={['column', 'column', 'row']}
      justifyContent="center"
      spacing={6}
      {...rest}
    >
      {!hasNoSidebar && (
        <UserNavigation
          avatar={user?.avatar}
          firstName={user?.name?.first || ''}
          personalPageUrl={user?.customPersonalPageUrl || user?.personalPageUrl}
          eventName={eventInfo?.name || eventConfig?.publicName}
        />
      )}

      <Box>{children}</Box>
    </Stack>
  );
};
